import { call, put, delay } from 'redux-saga/effects';
import { select as typedSelect } from 'typed-redux-saga';
import { finishLoading, startLoading } from '../Redux/LoadingActions';
import type { StartRecipientUpload } from '../Redux/RecipientUploadActions';
import { setRecipientUploadError } from '../Redux/RecipientUploadActions';
import { pushError, setSagaMessage } from '../Redux/ApplicationActions';
import { refetchRecipientUploadRecords } from '../Utils/hooks';
import type { RootState } from '../Redux';
import type { ApiRecipientUploadRecord } from '../Utils/apiTypes';

export function* startRecipientUploadSaga(action: StartRecipientUpload) {
  const { recipientUpload } = action;

  yield delay(50);
  yield put(startLoading('recipientUpload'));
  yield put(setRecipientUploadError());

  const root = (import.meta.env.VITE_API_ROOT || '').replace(/\/$/, '');
  const apiPath = `${root}/recipients/upload`;

  try {
    const token = yield* typedSelect((state: RootState) => state.auth.accessToken);

    const form = new FormData();
    form.append('recipients', recipientUpload.file);

    const headers = {
      Apikey: import.meta.env.VITE_API_KEY || '',
      Authorization: `Bearer ${token}`,
    };

    const result: ApiRecipientUploadRecord = yield fetch(apiPath, {
      method: 'POST',
      headers,
      body: form,
    }).then((response) => response.json());

    if (result.request_error) {
      const errors = result.request_error.map((fieldError) => ({
        field: fieldError.parameter_name.replaceAll('_', ' ').replace(/^(\d+)\.(.+)$/gm, 'Row $1: $2'),
        message: fieldError.violated_constraints.join(' '),
      }));
      yield put(setRecipientUploadError(errors));
    } else {
      yield put(setSagaMessage('Success', `Successfully uploaded ${result.number_of_records} records`, '', false));
    }

    yield call(refetchRecipientUploadRecords);
  } catch (error) {
    const uploadError = error instanceof Error ? error : new Error('Unknown recipient upload error');
    yield put(pushError('Failed to upload recipient csv', uploadError));
  } finally {
    yield put(finishLoading('recipientUpload'));
  }
}
